// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Confirmation_wrapper__3o0cN","confirmation":"Confirmation_confirmation__1DqtV","textBlock":"Confirmation_textBlock__3LGeJ","buttons":"Confirmation_buttons__2E2LM"};